import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SerializeService {

  constructor() { }

  public serialize(data:any) {
    var seen: any = [];

    let strData = JSON.stringify(data, function (key, val) {
      if (val != null && typeof val == 'object') {
        if (seen.indexOf(val) >= 0) {
          return;
        }
        seen.push(val);
      }
      return val;
    });
    return strData;
  }

  copyToClipboard(value: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = value;
  
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
}
